module.exports = __webpack_public_path__ + "static/media/about-mobile.d83e3c08.svg";